export default "__VITE_ASSET__CWI5VDMI__"